import { Loader2 } from 'lucide-react';

export default function LoadingSpinner({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-2 text-neutral-600 dark:text-neutral-300">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
